/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Attachment: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M8.5 23.0998C6.6 23.0998 4.7 22.3998 3.2 20.8998C1.8 19.4998 1 17.5998 1 15.5998C1 13.5998 1.8 11.6998 3.2 10.2998L11 2.4998C13.1 0.399805 16.6 0.399805 18.8 2.4998C21 4.5998 20.9 8.0998 18.8 10.2998L11.7 17.3998C10.3 18.7998 8.1 18.7998 6.7 17.3998C5.3 15.9998 5.3 13.7998 6.7 12.3998L12.7 6.3998C13.1 5.9998 13.7 5.9998 14.1 6.3998C14.5 6.7998 14.5 7.3998 14.1 7.7998L8.1 13.7998C7.5 14.3998 7.5 15.2998 8.1 15.8998C8.7 16.4998 9.6 16.4998 10.2 15.8998L17.3 8.7998C18 8.0998 18.3 7.2998 18.3 6.2998C18.3 5.3998 17.9 4.4998 17.3 3.7998C15.9 2.3998 13.7 2.3998 12.4 3.7998L4.6 11.5998C3.6 12.5998 3 13.9998 3 15.4998C3 16.9998 3.6 18.2998 4.6 19.3998C6.7 21.4998 10.2 21.4998 12.4 19.3998L21.2 10.5998C21.6 10.1998 22.2 10.1998 22.6 10.5998C23 10.9998 23 11.5998 22.6 11.9998L13.8 20.7998C12.4 22.3998 10.5 23.0998 8.5 23.0998Z'
      fill='currentColor'
    />
  </React.Fragment>
)
